module.exports = __webpack_public_path__ + "img/871.42874f8c.gif";